import { BodyBasedExpression } from '../Expression.js';
export class UnionExpression extends BodyBasedExpression {
    evaluate(visitor, localVariables) {
        const source = this.getSource()
            .evaluate(visitor, localVariables);
        const body = this.getBody()
            .evaluate(visitor, localVariables);
        if (source instanceof Array && body instanceof Array) {
            return source.concat(body);
        }
        return [];
    }
}
//# sourceMappingURL=UnionExpression.js.map